module.exports = __webpack_public_path__ + "avatar-akl.2931e507.png";